import { useState } from 'react';
import { RiUploadCloud2Line } from 'react-icons/ri';
import ImageWithFallback from '../shared/ImageWithFallback';
import SlidingModal from '../home/mobile/SlidingModal';
export const avatars = [{
  name: 'Einstein',
  file: 'ava1.png'
}, {
  name: 'Marie Curie',
  file: 'ava12.png'
}, {
  name: 'Newton',
  file: 'ava2.png'
}, {
  name: 'Rosa Parks',
  file: 'ava36.png'
}, {
  name: 'MLK Jr.',
  file: 'ava17.png'
}, {
  name: 'Grace Hopper',
  file: 'ava25.png'
}, {
  name: 'Sun Tzu',
  file: 'ava5.png'
}, {
  name: 'Joan of Arc',
  file: 'ava28.png'
}, {
  name: 'Ramanujan',
  file: 'ava14.png'
}, {
  name: 'Nina Simone',
  file: 'ava24.png'
}, {
  name: 'Beethoven',
  file: 'ava6.png'
}, {
  name: 'Amelia Earhart',
  file: 'ava26.png'
}, {
  name: 'Nietzsche',
  file: 'ava7.png'
}, {
  name: 'Du Chatelet',
  file: 'ava19.png'
}, {
  name: 'George Washington Carver',
  file: 'ava20.png'
}, {
  name: 'Simone de Beauvoir',
  file: 'ava23.png'
}, {
  name: 'Da Vinci',
  file: 'ava8.png'
}, {
  name: 'Maya Angelou',
  file: 'ava29.png'
}, {
  name: 'Dali',
  file: 'ava9.png'
}, {
  name: 'Jane Austen',
  file: 'ava30.png'
}, {
  name: 'Confucius',
  file: 'ava10.png'
}, {
  name: 'Hannah Arendt',
  file: 'ava31.png'
}, {
  name: 'Plato',
  file: 'ava3.png'
}, {
  name: 'Wollstonecraft',
  file: 'ava21.png'
}, {
  name: 'Pythagoras',
  file: 'ava11.png'
}, {
  name: 'Virgina Woolf',
  file: 'ava22.png'
}, {
  name: 'Hemmingway',
  file: 'ava13.png'
}, {
  name: 'Emily Dickinson',
  file: 'ava33.png'
}, {
  name: 'Tesla',
  file: 'ava4.png'
}, {
  name: 'Mary Shelley',
  file: 'ava35.png'
}, {
  name: 'Darwin',
  file: 'ava15.png'
}, {
  name: 'Henrietta Lacks',
  file: 'ava37.png'
}, {
  name: 'Mozart',
  file: 'ava16.png'
}, {
  name: 'Gandhi',
  file: 'ava18.png'
}, {
  name: 'Lee Kuan Yew',
  file: 'ava40.png'
}, {
  name: 'James Baldwin',
  file: 'ava27.png'
}, {
  name: 'WEB Du Bois',
  file: 'ava32.png'
}, {
  name: 'Alexander the Great',
  file: 'ava34.png'
}, {
  name: 'George Washington',
  file: 'ava38.png'
}, {
  name: 'Napolean',
  file: 'ava39.png'
}];
export default function SelectPfp({
  setPfp,
  disabled
}) {
  const [selected, setSelected] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  function toggleModal() {
    if (disabled) return;
    setIsModalOpen(!isModalOpen);
  }
  const handleSelect = avatar => {
    setSelected({
      file: avatar.file,
      name: avatar.name
    });
    setPfp(avatar.file);
    setTimeout(() => toggleModal(), 500);
  };
  return <div className='pt-4' data-sentry-component="SelectPfp" data-sentry-source-file="SelectPfp.tsx">
      <div onClick={() => toggleModal()} className={`relative ta-c m-auto justify-center w-[100px] h-[100px] items-center ${disabled ? '' : 'hover:scale-110'}`}>
        {selected && selected.file !== null ? <ImageWithFallback src={`/static/genie/${selected && selected.file !== null ? selected.file : 'upload.png'}`} width={91} height={92} alt='upload' className={`${!selected ? 'opacity-1' : ''} ${disabled ? 'opacity-30' : ''} rounded-xl`} /> : <div className='w-[91px] h-[92px] gradient-sides border-[#FFA3C8] border-[2px]'></div>}

        {!selected ? <RiUploadCloud2Line className='w-[24px] h-[24px] absolute top-[35px] left-[38px]' /> : <div className='whitespace-nowrap absolute bottom-0 left-1/2 transform -translate-x-1/2 w-fit text-white text-[10px] bg-gray-900 bg-opacity-75 px-3 py-[1px] rounded-full'>
            {selected.name}
          </div>}
      </div>

      <SlidingModal isOpen={isModalOpen} onClose={toggleModal} data-sentry-element="SlidingModal" data-sentry-source-file="SelectPfp.tsx">
        <div className='pt-4 px-4 ta-l'>
          <p className='text-[14px] text-genius-cream mb-4'>Choose a Profile Picture</p>

          <div className='max-w-[360px] justify-center ta-c m-auto grid grid-cols-2 gap-4 mt-4'>
            {avatars.map((avatar, index) => <div key={avatar.file} className='relative'>
                <ImageWithFallback src={`/static/genie/${avatar.file}`} width={200} height={200} alt={`Avatar ${index + 1}`} className={`cursor-pointer rounded-lg`} onClick={() => handleSelect(avatar)} />
                {selected && selected.file === avatar.file ? <div className='absolute top-2 right-2 bg-genius-blue rounded-full p-2 border-[1px] border-white'></div> : <div className='absolute top-2 right-2 bg-genius-pink rounded-full p-2'></div>}
                <div className='absolute top-2 left-2 text-white text-[14px] bg-gray-900 bg-opacity-75 px-3 py-[1px] rounded-full'>
                  {avatar.name}
                </div>
              </div>)}
          </div>
        </div>
      </SlidingModal>
    </div>;
}